import { defineMeta } from '@/registry/types';

export const iconButtonMeta = defineMeta({
  name: 'IconButton',
  level: 'atom',
  category: 'input',
  classification: 'mui-wrapper',
  description:
    'Icon-only action with an enforced accessible label, optional tooltip, semantic variants and a loading state.',
  baseLibrary: '@mui/material',
  muiEquivalent: 'IconButton',
  muiDocs: 'https://mui.com/material-ui/react-button/#icon-button',
  a2uiEquivalent: 'IconButton',
  importPath: '@/atoms/IconButton',
  requiredProps: ['icon', 'label'],
  optionalProps: [
    'variant',
    'tooltip',
    'tooltipPlacement',
    'loading',
    'size',
    'disabled',
    'onClick',
  ],
  props: [
    { name: 'icon', type: 'ReactNode', required: true, description: 'Icon element to render' },
    { name: 'label', type: 'string', required: true, description: 'Accessible name (aria-label)' },
    { name: 'variant', type: "'default' | 'primary' | 'danger'", default: "'default'" },
    { name: 'loading', type: 'boolean', default: 'false' },
  ],
  customVariants: ['default', 'primary', 'danger'],
  supportedStates: ['default', 'hover', 'disabled', 'loading'],
  designTokens: ['colors', 'radius'],
  accessibility: [
    'A `label` is required and rendered as `aria-label`.',
    'Loading sets `aria-busy` and disables interaction.',
    'Disabled buttons remain tooltip-hoverable via a span wrapper.',
  ],
  usageExamples: [
    '<IconButton icon={<DeleteIcon />} label="Delete" variant="danger" onClick={remove} />',
    '<IconButton icon={<RefreshIcon />} label="Refresh" tooltip="Refresh data" loading={busy} />',
  ],
  antiPatterns: [
    'Do not omit `label` - the button would be unreadable to screen readers.',
    'Do not use for text actions (use Button).',
  ],
  llmSafe: true,
  whenToUse: ['Toolbar actions', 'Row actions', 'Compact icon-only controls'],
  whenNotToUse: ['Primary labelled actions (use Button)', 'Floating primary action (use FAB)'],
});

export default iconButtonMeta;
